export default function () {
  return {
    products: [],
    tripId: null,
    showMissingRecipientDialog: false
  }
}
